import React, { useState } from "react";
import { Modal, Button } from "antd";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import "@react-pdf-viewer/core/lib/styles/index.css";

function PdfViewerModal({ pdfBlobUrl }) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleDownload = () => {
    if (pdfBlobUrl) {
      const link = document.createElement("a");
      link.href = pdfBlobUrl;
      link.download = "doktor_raporu.pdf"; // İndirilecek dosya adı
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <>
      <span className="text-sm">
        Hastanın sonuçlanan raporunu görmek için aşağıdaki butona
        tıklayabilirsiniz.
      </span>
      <Button className="flex p-4" type="primary" onClick={showModal}>
        <span className="p-1">
          <FilePdfOutlined />
        </span>
        <span className="p-1">
          <p>Sonuç Görüntüle</p>
        </span>
      </Button>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <span>Başvuru Raporu</span>
            <Button
              className="mr-8 p-4"
              onClick={handleDownload}
              type="default"
            >
              <DownloadOutlined className="p-4" />
            </Button>
          </div>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width="100%"
        style={{
          maxWidth: "100%", // Modalın ekran boyutuna göre genişliği
          top: 0, // Ekran üstünden biraz boşluk
          bottom: 0,
          left: 0,
          right: 0
        }}
        bodyStyle={{
          height: "100vh", // Modalın yüksekliği ekranın tamamı
          padding: 0, // İç boşluk yok
          overflow: "hidden" // Taşmaları engellemek için
        }}
      >
        {pdfBlobUrl ? (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden" // Fazla içeriği gizle
              }}
            >
              <Viewer
                fileUrl={pdfBlobUrl}
                defaultScale={window.innerWidth < 768 ? 0.5 : 1.2} // Mobilde ölçeği küçült
                style={{
                  width: "100%",
                  height: "100%"
                }}
              />
            </div>
          </Worker>
        ) : (
          <p style={{ textAlign: "center", marginTop: "20px" }}>
            PDF Yüklenemedi.
          </p>
        )}
      </Modal>
    </>
  );
}

export default PdfViewerModal;
